import BaseService from "./geral/BaseService";

const base = "ConsultaVeiculoController";

export default class VeiculoService extends BaseService{
    
    constructor(props){
        super(props)
    }

    // Serviços para consulta de veículos
    Listar = (placa, transpId, clienteId) => {
        return super.httpGet(`/${base}/Listar?placa=${placa}&transpId=${transpId}&clienteId=${clienteId}`);
    }

    ListarClientes = (transpId) => {
        return super.httpGet(`/${base}/ListarClientes?transpId=${transpId}`);
    }

    ListarTransportadoras = () => {
        return super.httpGet(`/${base}/ListarTransportadoras`);
    }

    // Serviços para consulta de veículos aguardando CDTA

    ListarAguardandoCdta = () => {
        return super.httpGet(`/${base}/ListarAguardandoCDTA`)
    }
    
    Salvar = (arqv) => {
        let arquivo = new FormData()
        arquivo.append('file', arqv.file);
        return super.httpPost(`/${base}/SalvarAnexo?extensao=${arqv.extensao}&dscArquivo=${arqv.dscArquivo}&placaVeic=${arqv.placaVeic}&bookingNbr=${arqv.bookingNbr}&tvdtlsGkey=${arqv.tvdtlsGkey}&appoitmentNbr=${arqv.appoitmentNbr}`, arquivo)
    }

    ListarAnexos = (idAnexo="",placaVeic="",bookingNbr="",tvdtlsGkey="",appoitmentNbr="") => {
        return super.httpGet(`/${base}/ListarAnexos?idAnexo=${idAnexo}&placaVeic=${placaVeic}&bookingNbr=${bookingNbr}&tvdtlsGkey=${tvdtlsGkey}&appoitmentNbr=${appoitmentNbr}`);
    }

    exlcuirAnexos = (anexos = []) => {
        return super.httpPost(`/${base}/ExcluirAnexos`, anexos);
    }
    
    GerenciarAnexos = (dataAtend = "", placa = "", container = "", booking = "", posContainer = "") => {
        return super.httpGet(`/${base}/GerenciarAnexos?dataAtend=${dataAtend}&placa=${placa}&container=${container}&booking=${booking}&posContainer=${posContainer}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/VeiculoService.js